import type { FormatMessage } from '@atlassian/jira-shared-types/src/general.tsx';
import { ASSIGNEE_TYPE_PROJECT_LEAD, ASSIGNEE_TYPE_UNASSIGNED } from '../../../model/constants';
import messages from './messages';
import type { AssigneeTypeOption } from './types';

export const getDefaultAssigneeOptions = (
	formatMessage: FormatMessage,
): ReadonlyArray<AssigneeTypeOption> => [
	{
		label: formatMessage(messages.projectLeadOption),
		value: ASSIGNEE_TYPE_PROJECT_LEAD,
	},
	{
		label: formatMessage(messages.unassignedOption),
		value: ASSIGNEE_TYPE_UNASSIGNED,
	},
];
